import { GetTrackResponse, Track } from "../../proto/api_pb";
import { TrackObj } from "./types";

export const convertToTrackObj = (
  trackResponse: GetTrackResponse
): TrackObj => {
  const t: Track | undefined = trackResponse.getTrack();
  const tUrl = trackResponse.getTrackVersion()?.getTrackUrl();
  return {
    track: t,
    trackUrl: tUrl!,
    isPlaying: false,
    waveSurfer: undefined,
  };
};
